export const MERGE_REQUEST_PANEL_ID = "merge-request";
